module.exports = __webpack_public_path__ + "../resources/images/illustration_folder-8b238e2cdcd898602cf8db47868bc338.svg";